module.exports = __webpack_public_path__ + "static/Regulator_panel-e366549b1d5b3b735893d9bd051d511d.png";